import { Helmet } from 'react-helmet-async';

/**
 * Componente SEO reutilizable para manejar meta tags dinámicamente
 */
const SEOHead = ({
  title = "Revvly - Software para Talleres Automotrices",
  description = "Software líder para gestión de talleres automotrices en Chile. Aumenta tu productividad hasta 300% con nuestro sistema integral.",
  keywords = "software taller automotriz, gestión talleres Chile, sistema talleres, software mecánico",
  image = "https://revvly.cl/img/screenshots/features.png",
  url = "https://revvly.cl",
  type = "website",
  locale = "es_CL",
  structuredData = null
}) => {
  
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Revvly",
    "description": description,
    "url": url,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "CLP",
      "description": "30 días de prueba gratuita"
    },
    "creator": {
      "@type": "Organization",
      "name": "Revvly",
      "url": "https://revvly.cl"
    }
  };

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>
      
      {/* Meta Tags */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Revvly" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;